import { usePersistedState } from './persist/usePersistedState';
import { StorageType } from '../utilities/constants/common';

export enum PreAuthAction {
  SHOW_AI_TOOLS_SUBSCRIPTION_POPUP = 'showAiToolsSubscriptionPopup',
  COPY_TEXT_ACTION = 'copyTextAction',
  DOWNLOAD_TEXT_ACTION = 'downloadTextAction',
}

const usePreAuthAction = () => {
  const [userPreAuthAction, setUsePreAuthAction] =
    usePersistedState<PreAuthAction | null>(
      'userPreAuthAction',
      null,
      StorageType.SESSION
    );

  const setPreAuthAction = (action: PreAuthAction) => {
    setUsePreAuthAction(action);
  };

  const clearPreAuthAction = () => {
    setUsePreAuthAction(null);
  };

  return {
    userPreAuthAction,
    setPreAuthAction,
    clearPreAuthAction,
  };
};

export default usePreAuthAction;
